"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollProvider = exports.ScrollContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ScrollProvider = _ref => {
  let {
    children
  } = _ref;
  const [isScrollingDown, setIsScrollingDown] = (0, _react.useState)(false);
  const [isScrollingUp, setIsScrollingUp] = (0, _react.useState)(false);
  const [scrollY, setScrollY] = (0, _react.useState)(0);
  const scrollYOffset = (0, _utils.getScrollOffsetY)();
  const foreLastScrollYPos = (0, _react.useRef)(scrollYOffset);
  const prevScrollY = (0, _react.useRef)(scrollYOffset);
  const recursionDetected = (0, _react.useRef)(false);
  const isTicking = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    const handleScroll = () => {
      if (recursionDetected.current !== false) {
        return;
      } // note: for delta scroll pos should be larger 0 to avoid taking browser bouncing effects
      // into account such as the one used in iOS when scrolling up at the top of the page!


      const lastScrollY = (0, _utils.getScrollOffsetY)();
      const scrollDelta = lastScrollY > 0 ? lastScrollY - prevScrollY.current : 0;

      if (!isTicking.current) {
        requestAnimationFrame(() => {
          // note: this happens if setting a fixed header gets follwed by a disappearing
          // scrollbar as page gets too small, but this would force an infinite loop in
          // browser, as the scroll position then jumps to 0 - stop updates in this case
          recursionDetected.current = lastScrollY === 0 && foreLastScrollYPos.current === 0;
          foreLastScrollYPos.current = prevScrollY.current;
          prevScrollY.current = lastScrollY;
          setIsScrollingDown(scrollDelta > 0);
          setIsScrollingUp(scrollDelta < 0);
          setScrollY(lastScrollY);
          isTicking.current = false;
        });
        isTicking.current = true;
      }
    };

    document.addEventListener("scroll", handleScroll, false);
    return () => {
      document.removeEventListener("scroll", handleScroll, false);
    };
  }, []);
  (0, _react.useEffect)(() => {
    const handleResize = () => {
      recursionDetected.current = false;
    };

    document.addEventListener("resize", handleResize, false);
    return () => {
      document.removeEventListener("resize", handleResize, false);
    };
  }, []);
  const value = (0, _react.useMemo)(() => ({
    isScrollingDown,
    isScrollingUp,
    scrollY
  }), [isScrollingDown, isScrollingUp, scrollY]);
  return /*#__PURE__*/_react.default.createElement(ScrollContext.Provider, {
    value: value
  }, children);
};

exports.ScrollProvider = ScrollProvider;
const ScrollContext = /*#__PURE__*/(0, _react.createContext)();
exports.ScrollContext = ScrollContext;